// Marken-Erkennung per Hostname: gorental24.de = reine Mietwagen-Seite, sonst GoTransfer24.
const host = typeof window !== "undefined" ? window.location.hostname : "";
export const isRentalBrand = /(^|\.)gorental24\.de$/.test(host);

export const brand = isRentalBrand
  ? {
      key: "gorental24", name: "GoRental24", siteBase: "https://www.gorental24.de",
      logo: "/images/logos/gr-24-blue-black.png", logoWhite: "/images/logos/gorental24-white.svg",
      email: "info@gotransfer24.de", legalReviewed: false,
    }
  : { key: "gotransfer24", name: "GoTransfer24", siteBase: "https://www.gotransfer24.de" };

// Die Rental-Seite ruft die API same-origin auf (/api via nginx), alle anderen wie bisher absolut.
export const apiBase = (absolute) => (isRentalBrand ? "/api" : absolute);

// Marken-Wechsel: Reiter Transfer/Flüge → gotransfer24.de, Reiter Mietwagen → gorental24.de
export const TRANSFER_SITE = "https://www.gotransfer24.de";
export const RENTAL_SITE = "https://www.gorental24.de";
const previewSuffix = () => {
  try { const t = sessionStorage.getItem("gt24_rental_preview"); return t ? `?preview=${encodeURIComponent(t)}` : ""; } catch { return ""; }
};
export const siteForMode = (mode) => (mode === "rental" ? `${RENTAL_SITE}/${previewSuffix()}` : mode === "flights" ? `${TRANSFER_SITE}/?mode=flights` : `${TRANSFER_SITE}/`);
